import { getNextRangeSelection } from "../../../../helpers/rangeSelection";

export const getNextSnapshotSelection = getNextRangeSelection;
